/* Progressive enhancements. Native forms remain available without JavaScript. */
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  let serial = 0;
  function searches() {
    document.querySelectorAll('form[role="search"] input[name="q"], form.search input[name="q"]').forEach(input => {
      if (input.dataset.nsSearchReady) return;
      input.dataset.nsSearchReady = 'true';
      const form = input.form;
      form.classList.add('ns-search-form');
      const panel = document.createElement('div');
      panel.className = 'ns-search-suggestions'; panel.id = `ns-suggestions-${++serial}`; panel.hidden = true;
      panel.setAttribute('role', 'region'); panel.setAttribute('aria-label', 'Search suggestions');
      const status = document.createElement('span'); status.className = 'visually-hidden'; status.setAttribute('role','status');
      form.append(panel,status);
      input.setAttribute('autocomplete','off'); input.setAttribute('aria-controls',panel.id);
      let timer, controller, generation = 0;
      function close() { panel.hidden = true; }
      input.addEventListener('input', () => {
        clearTimeout(timer); controller?.abort(); const requestId = ++generation;
        const query = input.value.trim(); close(); panel.replaceChildren(); status.textContent = '';
        if (query.length < 2) return;
        timer = setTimeout(async () => {
          controller = new AbortController();
          const url = new URL(root + 'search/suggest',location.origin);
          url.search = new URLSearchParams({q:query,'resources[type]':'product,article,collection','resources[limit]':'4','resources[limit_scope]':'each','resources[options][unavailable_products]':'last',section_id:'ns-predictive-search'});
          try {
            const response = await fetch(url,{signal:controller.signal,credentials:'same-origin'});
            if (!response.ok) throw new Error('Search unavailable');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const results = doc.querySelector('[data-ns-search-results]');
            if (requestId !== generation || !results || !input.isConnected) return;
            panel.replaceChildren(results);
            panel.hidden = document.activeElement !== input;
            status.textContent = results.querySelector('[data-ns-result-count]')?.textContent || '';
          } catch(error) { if (error.name !== 'AbortError' && requestId === generation) { close(); status.textContent = 'Press Enter to search the store.'; } }
        },200);
      });
      input.addEventListener('focus',()=>{ if(panel.children.length && input.value.trim().length >= 2) panel.hidden=false; });
      form.addEventListener('keydown',event=>{
        if(event.key==='Escape'){ ++generation;clearTimeout(timer);controller?.abort();input.focus();close();event.stopPropagation();return; }
        if(panel.hidden || !['ArrowDown','ArrowUp'].includes(event.key))return;
        const links=[...panel.querySelectorAll('a[href]')]; if(!links.length)return;
        event.preventDefault();const current=links.indexOf(document.activeElement);
        const next=event.key==='ArrowDown'?Math.min(current+1,links.length-1):current-1;
        if(next<0)input.focus();else links[next].focus();
      });
      // Keep suggestions reachable inside Cascade's existing header focus trap.
      form.addEventListener('keydown',event=>{
        if(event.key!=='Tab' || panel.hidden || !form.closest('.site-header'))return;
        const links=[...panel.querySelectorAll('a[href]')]; if(!links.length)return;
        if(!event.shiftKey && document.activeElement===form.querySelector('button[type="submit"]'))event.stopPropagation();
        if(!event.shiftKey && document.activeElement===links.at(-1)){event.preventDefault();event.stopPropagation();input.focus();}
        if(event.shiftKey && document.activeElement===input){event.preventDefault();event.stopPropagation();links.at(-1).focus();}
      },true);
      form.addEventListener('focusout',()=>setTimeout(()=>{if(!form.contains(document.activeElement))close();},0));
      document.addEventListener('pointerdown',event=>{if(!form.contains(event.target))close();});
    });
  }
  let stopBuy = () => {};
  function mobileBuy() {
    stopBuy();
    const bar=document.querySelector('[data-ns-mobile-buy]');
    if(!bar)return;
    const form=document.querySelector('#MainContent form[action*="/cart/add"]');
    const primary=form?.querySelector('button[type="submit"][name="add"],button[type="submit"]');
    if(!form || !primary)return;
    let variants=[];try{variants=JSON.parse(document.getElementById('ns-buy-variants').textContent);}catch{return;}
    const button=bar.querySelector('[data-ns-mobile-add]'), label=bar.querySelector('[data-ns-mobile-variant]'), price=bar.querySelector('[data-ns-mobile-price]');
    const viewport=matchMedia('(max-width: 749px)');
    function update() {
      const id=new FormData(form).get('id');const variant=variants.find(v=>String(v.id)===String(id));
      label.textContent=variant && variant.title!=='Default Title'?variant.title:'';
      price.textContent=variant?.price || '';
      button.disabled=primary.disabled || !variant?.available;
      button.textContent=!variant?'Choose options':!variant.available?'Sold out':primary.disabled?'Please wait…':'Add to cart';
      const above=primary.getBoundingClientRect().bottom<=0;
      bar.hidden=!(viewport.matches && above);
      document.body.classList.toggle('ns-has-mobile-buy',!bar.hidden);
    }
    function delayed(){setTimeout(update,0);}
    function buy(){ if(!button.disabled) { if(form.reportValidity())form.requestSubmit(primary);else {form.scrollIntoView({block:'center',behavior:'smooth'});} } }
    button.addEventListener('click',buy);
    form.addEventListener('change',delayed);form.addEventListener('click',delayed);form.addEventListener('input',delayed);
    const observer=new MutationObserver(update);observer.observe(form,{subtree:true,attributes:true,attributeFilter:['disabled','value','aria-pressed']});
    window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);
    update();
    stopBuy=()=>{observer.disconnect();button.removeEventListener('click',buy);form.removeEventListener('change',delayed);form.removeEventListener('click',delayed);form.removeEventListener('input',delayed);window.removeEventListener('scroll',update);window.removeEventListener('resize',update);bar.hidden=true;document.body.classList.remove('ns-has-mobile-buy');};
  }
  searches();mobileBuy();
  document.addEventListener('shopify:section:load',()=>{searches();mobileBuy();});
})();
